import {
  Radio as HeadlessUIRadio,
  RadioGroup as HeadlessUIRadioGroup,
  RadioGroupProps as HeadlessUIRadioGroupProps,
  RadioProps as HeadlessUIRadioProps,
  Label,
} from "@headlessui/react";
import { twMerge } from "tailwind-merge";

import InfoPopup from "../InfoPopup/InfoPopup";

interface RadioProps extends HeadlessUIRadioProps {
  disabledPopupText?: string;
  label: string;
}

const Radio = ({ label, disabledPopupText, ...rest }: RadioProps) => {
  return (
    <HeadlessUIRadio {...rest} className="flex">
      {({ checked, disabled }) => (
        <div
          className={twMerge(
            "flex cursor-pointer items-center rounded-full p-2 pt-1",
            checked && "bg-grey1",
            disabled && "cursor-not-allowed",
          )}
        >
          <div className="flex size-5 items-center justify-center rounded-full border border-black">
            <span
              className={twMerge(
                "size-3 rounded-full bg-black",
                checked ? "inline-block" : "hidden",
              )}
            />
          </div>
          <Label
            className={twMerge(
              "mt-px flex items-center pl-2 text-sm",
              disabled && "text-grey4",
            )}
          >
            {label}
            {disabled && disabledPopupText && (
              <InfoPopup
                id={rest.value}
                size={15}
                className="ml-2 inline-block"
                width="350px"
                text={disabledPopupText}
              />
            )}
          </Label>
        </div>
      )}
    </HeadlessUIRadio>
  );
};

export interface RadioGroupOption {
  value: string;
  label: string;
  disabled?: boolean;
  disabledPopupText?: string;
}

interface RadioGroupProps extends HeadlessUIRadioGroupProps {
  options: RadioGroupOption[];
}

export const RadioGroup = (props: RadioGroupProps) => {
  const { options, ...rest } = props;

  return (
    <HeadlessUIRadioGroup {...rest}>
      {options.map((option) => (
        <Radio
          key={option.value}
          value={option.value}
          label={option.label}
          disabled={option.disabled}
          disabledPopupText={
            option.disabled ? option.disabledPopupText : undefined
          }
        />
      ))}
    </HeadlessUIRadioGroup>
  );
};
